import riskAnalysisStore from '../../../sales-conversation/src/store/redux/store';
import { useLocale } from '../../../../i18n';
import usePartyId from '../../../common/src/hooks/query-params/usePartyId';
import { CreateFlowPayload } from '../../../flows/src/types/ApiTypes';
import useAuth from '../../../app/src/features/authentication/hooks/useAuth';
import { getConversationById } from '../../../conversations/src/features/detail/shared/api/getConversationById';
import cogoToast from 'cogo-toast';
import { useTranslation } from 'react-i18next';
import { SubjectTypes } from '../../../../types/RiskAnalaysis';

interface RiskAnalysisFlowQueryParams {
  getFlowPayload: (
    sessionId?: string,
    resumedSession?: boolean,
  ) => Promise<CreateFlowPayload>;
}

const useRiskAnalysisPayload = (): RiskAnalysisFlowQueryParams => {
  const { t } = useTranslation();
  const { userCountry } = useLocale();
  let { subjects: selectedSubjects } =
    riskAnalysisStore.getState().riskAnalysisSelection;
  const { partyId: selectedPartyId } = riskAnalysisStore.getState().selection;
  const partyIdQueryParam = usePartyId();
  const partyId = selectedPartyId || partyIdQueryParam;

  const { campaign } = useAuth();

  const getFlowPayload = async (
    sessionId?: string,
    resumedSession?: boolean,
  ) => {
    let subjects;

    if (resumedSession && sessionId) {
      try {
        const data = await getConversationById(sessionId);

        if (data) {
          selectedSubjects = data.chosen_subjects as SubjectTypes[];
        }
      } catch (_) {
        cogoToast.error(t('Something went wrong'));
      }
    }

    if (campaign) {
      subjects = campaign.risk_analysis_subjects || [];
    } else subjects = selectedSubjects;

    return {
      country_code: userCountry,
      ...(subjects.length > 0 && { subject: subjects }),
      ...(campaign?.short_id && { campaign_id: campaign?.short_id }),
      ...(partyId && { party_id: partyId }),
    };
  };

  return { getFlowPayload };
};

export default useRiskAnalysisPayload;
